import { render } from "./Stats.vue?vue&type=template&id=567a341b&scoped=true&ts=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=567a341b&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567a341b"]])

export default __exports__